import { render } from "./TicketPrintCount.vue?vue&type=template&id=32f28e5c&scoped=true"
import script from "./TicketPrintCount.vue?vue&type=script&lang=js"
export * from "./TicketPrintCount.vue?vue&type=script&lang=js"

import "./TicketPrintCount.vue?vue&type=style&index=0&id=32f28e5c&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f28e5c"]])

export default __exports__